import { Button, Col, Row } from "react-bootstrap";
import type { ApiResource } from "../../../hooks/useApiResource";
import type { PkMilestones, PkStreak, PkStreaks } from "../../../types/playerPk";
import { formatEtDateRange } from "../../../utils/etDate";
import SkeletonBlock from "../../common/SkeletonBlock";
import "../../epicLeaderboard/epicLeaderboard.css";
import "./pk.css";

const StreakLine = ({
  label,
  streak,
  tone
}: {
  label: string;
  streak: PkStreak | null;
  tone: "pk-pos" | "pk-neg";
}) => (
  <div className="mb-3">
    <div className="epic-lb-card-title mb-1">{label}</div>
    {streak ? (
      <>
        <div className={`pk-tile-value ${tone}`}>{streak.length}</div>
        <div className="epic-lb-muted">
          {formatEtDateRange(streak.startEt, streak.endEt)}
        </div>
      </>
    ) : (
      <div className="epic-lb-muted">None</div>
    )}
  </div>
);

const StreakColumn = ({ title, streaks }: { title: string; streaks: PkStreaks }) => (
  <div className="pk-card">
    <div className="pk-subtitle">{title}</div>
    <StreakLine
      label="Best kill streak"
      streak={streaks.bestKill}
      tone="pk-pos"
    />
    <StreakLine
      label="Worst losing streak"
      streak={streaks.worstLoss}
      tone="pk-neg"
    />
  </div>
);

type Props = {
  inRange: PkStreaks;
  allTime: ApiResource<PkMilestones>;
};

// Streaks count kills and deaths in order; assists are ignored.
const StreaksCard = ({ inRange, allTime }: Props) => (
  <Row className="g-3">
    <Col xs={12} md={6}>
      <StreakColumn title="In this range" streaks={inRange} />
    </Col>
    <Col xs={12} md={6}>
      {allTime.data ? (
        <StreakColumn
          title="All time"
          streaks={allTime.data.allTimeStreaks}
        />
      ) : allTime.error ? (
        <div className="pk-card text-center" role="alert">
          <div className="mb-2">Couldn't load all-time streaks.</div>
          <Button size="sm" variant="outline-light" onClick={allTime.reload}>
            Retry
          </Button>
        </div>
      ) : (
        <SkeletonBlock height={190} style={{ borderRadius: 12 }} />
      )}
    </Col>
  </Row>
);

export default StreaksCard;
